import React from "react";
import CustomLoader from "../../../components/Common/CustomLoader";
import DefaultAppLogo from '../../../assets/images/lystfacelogos/DefaultAppLogo.svg'
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { ManageAppIcon } from "../../../components/Common/SvgIcons";

const AppsList = ({ appsList, loading, responseStatus, responseMessage, from }) => {
    const ApplicationState = useSelector(state => state.Application)
    const { applicationIcon, appId } = ApplicationState


    return (
        <div className={`${appsList.length === 0 ? 'empty-list-view' : 'add-app-description-container'}`}>
            {
                responseStatus === "Error" ?
                    <span>{responseMessage}</span>
                    :
                    loading ?
                        <CustomLoader text={"Fetching apps list...."} />
                        :
                        appsList.length === 0 && !loading ?
                            <img src={"https://img-assets.lystface.com/web/NoAppIcon.svg"} alt="No App Icon" />
                            :
                            !loading &&
                            <div>
                                {appsList.length > 0 && (from === "home" ? appsList.slice(0, 3) : appsList).map((app, i) => (
                                    <div className="app-container" key={app.app_id}>
                                        <div className="app-info">
                                            {app?.app_icon ?
                                                <img src={app.app_id === appId ? applicationIcon ? applicationIcon : app?.app_icon : app?.app_icon} className="app-icon" />
                                                :
                                                <span className="account-profile-name">{app?.app_name.charAt(0).toUpperCase()}</span>


                                            }
                                            <div className="app-desc">
                                                <span className="app-title">{app.app_name}</span>
                                                <span className="app-subtitle">{app.app_desc}</span>
                                            </div>
                                        </div>
                                        <Link to={`/application/${app?.app_id}`}>
                                            <div className="manage-button">
                                                {ManageAppIcon}
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </div>
            }
        </div>
    )
}
export default AppsList;
